import { IOffer } from '../types';
import { IHouseOfferHistoryDesktopSchema } from '../../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryDesktopSchema';

export const prepareOffers = (apiOffers: IHouseOfferHistoryDesktopSchema[]): IOffer[] => {
  return apiOffers.map(offer => {
    return {
      id: offer.id,
      card: {
        img: offer.previewPhoto,
        link: offer.link,
        title: offer.title,
        expoTime: offer.exposition,
      },
      offerStart: {
        date: offer.dateStart,
        price: offer.priceStart,
        priceSqm: offer.priceStartSqm,
      },
      offerActual: {
        date: offer.dateEnd,
        price: offer.priceEnd,
        priceSqm: offer.priceEndSqm,
        priceDiff: offer.priceDiff,
      },
      offerValuation: {
        price: offer.estimatedPrice,
        priceSqm: offer.estimatedPriceSqm,
      },
    };
  });
};
